module.exports = __webpack_public_path__ + "static/media/next.4a25cc13.svg";